import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar os arquivos de tradução
import enTranslations from './locales/en.json';
import ptTranslations from './locales/pt.json';

const resources = {
  'en-US': {
    translation: enTranslations
  },
  'pt-BR': {
    translation: ptTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    debug: false,

    interpolation: {
      escapeValue: false, // React já faz escape por padrão
    },

    detection: {
      // Ordem de detecção: primeiro localStorage, depois navegador, depois htmlTag
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache no localStorage
      caches: ['localStorage'],
      // Configurações específicas para detecção do navegador
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      // Converter códigos de idioma do navegador
      convertDetectedLanguage: (lng: string) => {
        // Se o idioma detectado começar com 'pt', usar 'pt-BR'
        if (lng.startsWith('pt')) return 'pt-BR';
        // Caso contrário, usar 'en-US' como padrão
        return 'en-US';
      }
    },
  });

export default i18n;